import { gql } from "@apollo/client";
import { AccountFragment } from "fragments/account";

export const OrganizationFragment = gql`
  fragment OrganizationFragment on Organization {
    id
    orgId
    description
    createdAt
    updatedAt
  }
`;




export const get = gql`
  query OrganizationList($domain: String!, $orgId: String!) {
    viewer {
      id
      account {
        ...AccountFragment
        domains {
          id
          get(domain: $domain){
            id
        organizations {
          id
          get(orgId: $orgId) {
              ...OrganizationFragment
          }
            }
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${OrganizationFragment}
`;


// Ranked full-text search over `description`. Its own document rather than a
// variant of `list`: SearchInput carries a query string and no ordering, because
// results come back in score order. The domain stays a variable — the model
// scopes the search to that tenant. See docs/search.md.
export const search = gql`
  query OrganizationSearch($domain: String!, $input: SearchInput!) {
    viewer {
      id
      account {
        id
        domains {
          id
          get(domain: $domain){
            id
            organizations {
              id
              search(input: $input) {
                id
                last
                items {
                  ...OrganizationFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${OrganizationFragment}
`;


export const list = gql`
  query OrganizationList($domain: String!, $input: ListInput) {
    viewer {
      id
      account {
        id
        domains {
          id
          get(domain: $domain){
            id
            organizations {
              id
              list(input: $input) {
                id
                last
                items {
                  ...OrganizationFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${OrganizationFragment}
`;



export const create = gql`
  mutation OrganizationNew($domain: String!, $input: OrganizationInputCreate!) {
    viewer {
      account {
        domains {
          get(domain: $domain){
            organizations {
              create(input: $input) {
                ...OrganizationFragment
              }
            }
          }
        }
      }
    }
  }
  ${OrganizationFragment}
`;




export const edit = gql`
mutation OrganizationUpdate($domain: String!, $orgId: String!, $input: OrganizationInputUpdate!) {
  viewer {
    account {
      domains {
        get(domain: $domain){
      organizations {
        get(orgId: $orgId){
        update(input: $input) {
          ...OrganizationFragment
        }
      }
      }
    }
  }
    }
  }
}
${OrganizationFragment}
`;


export const remove = gql`
mutation OrganizationUpdate($domain: String!, $orgId: String!) {
  viewer {
    account {
      domains {
        get(domain: $domain){
      organizations {
        get(orgId: $orgId){
        remove
      }
      }
    }
  }
    }
  }
}
`;


export const update = ({ domain }) => (cache) => {
  Object.keys(cache.data.data).forEach((key) => {
    if (key.includes(`${domain}/queries`)) {
      cache.data.delete(key);
    }
  });
};
